<template>
  <div id="Ranking">
    <div class="ranking-box" >
      <div class="title">
        <i class="iconfont" v-bind:class="icon"></i>
        {{ title }}
      </div>
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="今日排行" name="0">
            <rankingslist :data="datas"></rankingslist>
          </el-tab-pane>
          <el-tab-pane label="月度排行" name="1">
            <rankingslist :data="datas"></rankingslist>
          </el-tab-pane>
          <el-tab-pane label="年度排行" name="2">
            <rankingslist :data="datas"></rankingslist>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import rankingslist from "./RankingList.vue";
export default {
  name: "RankingClass",
  props: {
    type: Number,
    title: String,
    icon: String,
    id: String,
    data: Array
  },
  components: {
    rankingslist
  },
  data() {
    return {
      activeName: "0",
      datas: this.data
    };
  },
  methods: {
    handleClick() {
      if (this.activeName == "0") {
        this.$api.study
          .getTodayrank()
          .then(res => {
            this.datas = res.data.data;
          })
          .catch();
      } else if (this.activeName == "1") {
          this.$api.study
          .getMonthrank()
          .then(res => {
            this.datas = res.data.data;
          })
          .catch();
      }else  if (this.activeName == "2"){
          this.$api.study
          .getYearrank()
          .then(res => {
            this.datas = res.data.data;
          })
          .catch();
      }
    }
  }
};
</script>
<style scope lang="scss">
@import "./../../../assets/iconfont/iconfont.css";
#Ranking {
  width: 260px;
  .ranking-box {
    width: 186px;
    margin: 0 auto;
    .title {
      font-size: 16px;
      line-height: 40px;
      font-weight: bold;
      color: #000000;
      .iconfont {
        margin-right: 10px;
        font-size: 20px;
      }
    }
    .tabs {
      width: 230px;
      .el-tabs__item.is-disabled {
        font-size: 20px;
        color: #000000;
        padding-left: 25px;
        .iconfont {
          font-size: 20px;
        }
      }
      .el-tabs__nav-wrap::after,
      .el-tabs__active-bar {
        display: none;
      }
      .el-tabs__item {
        height: 20px;
        padding: 0 7px;
        font-size: 12px;
        line-height: 20px;
        color: #999999;
      }
      .el-tabs__item:hover {
        color: #25a257;
      }
      .is-active {
        color: #25a257;
      }
    }
  }
}
</style>
